import { grid } from "ionicons/icons";
import ProductObj from "../../../../OBJRep/Product.js";
import ProductStyles from "../../../../OBJRep/ProductStyles.js";
import {
  NAME_ABOVE_PRODUCT_LAYOUT,
  NAME_AND_PRICE_SIDE_BY_SIDE_PRODUCT_LAYOUT,
  NAME_BENEATH_PRODUCT_LAYOUT,
  PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
  THREE_COLUMNS_PRODUCT_LAYOUT,
  TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
} from "../../CanvasViewer/EncarteConstants.js";

/* THIS FILE IS RESPONSIBLE FOR STORING GRADE DE PRODUTOS OPTIONS

EACH GRADE IS MADE USING function: Products();
KEY POINTS TO GENERATE A NEW GRID:

-- HOW MANY PRODUCTS GOES INTO THE GRID;
-- HOW MANY ROWS AND COLUMNS THE GRID WILL HAVE;
-- FOR PRODUCTS THAT ARE TO BE HIGHLIGHTED IN ENCARTE BY TAKING MORE THAN ONE ROW AND COLUMN, 
   WE CHOOSE THE INDEX OF THE PRODUCT, THEN SET IT'S GRID-COLUMN AND GRID-ROW PROPERTY.
   THOSE PROPERTIES ARE PASSED TO function: Products(); IN AN ARRAY OF arrPositions[], arrColumns[],
   arrRows[]. WE CAN STILL PASS PRODUCT LAYOUT TOO AS AN ARRAY arrLayouts[];
*/

/* THIS FUNCTION DO 3 THINGS:
  -- CREATES A NEW PRODUCT OBJECT
  -- UPDATE PRODUCT STYLES WITH GRID-COLUMN, GRID-ROW AND PRODUCT LAYOUT
     PROPERTIES
  -- RETURN AN ARRAY OF PRODUCTS
*/

function products(
  quantity,
  arrPositions,
  arrColumns,
  arrRows,
  arrLayouts,
  arrayFontSizes,
) {
  const products = [];
  for (let i = 0; i < quantity; i++) {
    const p = ProductObj(i);
    p.styles = ProductStyles();
    if (arrayFontSizes) p.styles.fontSize = arrayFontSizes[i];
    else p.styles.fontSize = "32";
    products.push(p);
  }
  if (arrPositions) {
    for (let i = 0; i <= arrPositions.length - 1; i++) {
      if (arrColumns)
        products[arrPositions[i]].styles.gridColumn = arrColumns[i];
      if (arrRows) {
        products[arrPositions[i]].styles.gridRow = arrRows[i];
      }
      if (arrLayouts) {
        products[arrPositions[i]].styles.productLayout = arrLayouts[i];
      }
    }
  }
  return products;
}

function createGridConfig({
  quantity,
  positions,
  columns,
  rows,
  layouts,
  fontSizes,
  gridCols,
  gridRows,
}) {
  return {
    grid: Grid(gridCols, gridRows),
    products: products(quantity, positions, columns, rows, layouts, fontSizes),
  };
}

const FEED_GRID_3_PRODUCTS_1 = createGridConfig({
  quantity: 3,
  positions: [0, 1, 2],
  columns: ["1/2", "2/3", "3/4"],
  rows: ["1/2", "1/2", "1/2"],
  layouts: [
    NAME_BENEATH_PRODUCT_LAYOUT,
    NAME_BENEATH_PRODUCT_LAYOUT,
    NAME_BENEATH_PRODUCT_LAYOUT,
  ],
  fontSizes: ["38", "38", "38"],
  gridCols: 3,
  gridRows: 1,
});

const FEED_GRID_3_PRODUCTS_2 = createGridConfig({
  quantity: 3,
  positions: [0, 1, 2],
  columns: ["1/3", "1/2", "2/3"],
  rows: ["1/2", "2/3", "2/3"],
  layouts: [
    THREE_COLUMNS_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
  ],
  fontSizes: ["38", "33", "33"],
  gridCols: 2,
  gridRows: 2,
});

const FEED_GRID_4_PRODUCTS_1 = createGridConfig({
  quantity: 4,
  positions: [0, 1, 2, 3],
  columns: ["1/2", "3/4", "2/3", "2/3"],
  rows: ["1/3", "1/3", "1/2", "2/3"],
  layouts: [
    NAME_BENEATH_PRODUCT_LAYOUT,
    NAME_BENEATH_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
  ],
  fontSizes: ["38", "38", "28", "28"],
  gridCols: 3,
  gridRows: 2,
});

const FEED_GRID_4_PRODUCTS_2 = createGridConfig({
  quantity: 4,
  positions: [0, 1, 2, 3],
  columns: ["1/2", "2/4", "2/3", "3/4"],
  rows: ["1/3", "1/2", "2/3", "2/3"],
  layouts: [
    NAME_BENEATH_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    NAME_AND_PRICE_SIDE_BY_SIDE_PRODUCT_LAYOUT,
    NAME_AND_PRICE_SIDE_BY_SIDE_PRODUCT_LAYOUT,
  ],
  fontSizes: ["38", "38", "28", "28"],
  gridCols: 3,
  gridRows: 2,
});

const FEED_GRID_5_PRODUCTS_1 = createGridConfig({
  quantity: 5,
  positions: [0, 1, 2, 3, 4],
  columns: ["1/3", "3/5", "2/4", "1/2", "4/5"],
  rows: ["1/2", "1/2", "2/3", "2/3", "2/3"],
  layouts: [
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
  ],
  fontSizes: ["33", "33", "33", "24", "24"],
  gridCols: 4,
  gridRows: 2,
});

const FEED_GRID_5_PRODUCTS_2 = createGridConfig({
  quantity: 5,
  positions: [0, 1, 2, 3, 4],
  columns: ["1/2", "4/5", "2/4", "2/3", "3/4"],
  rows: ["1/3", "1/3", "2/3", "1/2", "1/2"],
  layouts: [
    NAME_BENEATH_PRODUCT_LAYOUT,
    NAME_BENEATH_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
  ],
  fontSizes: ["36", "36", "36", "24", "24"],
  gridCols: 4,
  gridRows: 2,
});

const FEED_GRID_6_PRODUCTS_1 = createGridConfig({
  quantity: 6,
  positions: [0, 1, 2, 3, 4, 5],
  columns: ["1/3", "1/3", "3/4", "4/5", "3/4", "4/5"],
  rows: ["1/2", "2/3", "1/2", "1/2", "2/3", "2/3"],
  layouts: [
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
  ],
  fontSizes: ["36", "36", "23", "23", "23", "23"],
  gridCols: 4,
  gridRows: 2,
});

const FEED_GRID_6_PRODUCTS_2 = createGridConfig({
  quantity: 6,
  positions: [0, 1, 2, 3, 4, 5],
  columns: ["1/2", "4/5", "2/3", "3/4", "2/3", "3/4"],
  rows: ["1/3", "1/3", "1/2", "1/2", "2/3", "2/3"],
  layouts: [
    NAME_BENEATH_PRODUCT_LAYOUT,
    NAME_BENEATH_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
  ],
  fontSizes: ["36", "36", "23", "23", "28", "28"],
  gridCols: 4,
  gridRows: 2,
});

const FEED_GRID_7_PRODUCTS_1 = createGridConfig({
  quantity: 7,
  positions: [0, 1, 2, 3, 4, 5, 6],
  columns: ["1/2", "3/4", "2/3", "2/3", "1/2", "2/3", "3/4"],
  rows: ["1/3", "1/3", "1/2", "2/3", "3/4", "3/4", "3/4"],
  layouts: [
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
  ],
  fontSizes: ["33", "33", "24", "24", "24", "24", "24"],
  gridCols: 3,
  gridRows: 3,
});

const FEED_GRID_7_PRODUCTS_2 = createGridConfig({
  quantity: 7,
  positions: [0, 1, 2, 3, 4, 5, 6],
  columns: ["1/6", "6/11", "1/3", "3/5", "5/7", "7/9", "9/11"],
  rows: ["1/2", "1/2", "2/3", "2/3", "2/3", "2/3", "2/3"],
  layouts: [
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
  ],
  fontSizes: ["30", "30", "21", "21", "21", "21", "21"],
  gridCols: 10,
  gridRows: 2,
});

const FEED_GRID_8_PRODUCTS_1 = createGridConfig({
  quantity: 8,
  positions: [0, 1, 2, 3, 4, 5, 6, 7],
  columns: ["1/3", "3/5", "5/7", "1/4", "4/7", "1/3", "3/5", "5/7"],
  rows: ["1/2", "1/2", "1/2", "2/3", "2/3", "3/4", "3/4", "3/4"],
  layouts: [
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
  ],
  fontSizes: ["24", "24", "24", "32", "32", "24", "24", "24"],
  gridCols: 6,
  gridRows: 3,
});

const FEED_GRID_8_PRODUCTS_2 = createGridConfig({
  quantity: 8,
  positions: [0, 1, 2, 3, 4, 5, 6, 7],
  columns: ["1/3", "3/5", "5/7", "1/4", "4/7", "1/3", "3/5", "5/7"],
  rows: ["2/3", "2/3", "2/3", "1/2", "1/2", "3/4", "3/4", "3/4"],
  layouts: [
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
  ],
  fontSizes: ["30", "30", "30", "36", "36", "30", "30", "30"],
  gridCols: 6,
  gridRows: 3,
});

/* THOSE ARRAYS WITH EACH FORMAT GRADE OPTIONS ARE EXPORTED AND USED IN GridMenuView.jsx */

export const FEED_GRIDS = [
  {
    title: "Grade com 3 produtos",
    gridsArr: [FEED_GRID_3_PRODUCTS_1, FEED_GRID_3_PRODUCTS_2],
  },
  {
    title: "Grade com 4 produtos",
    gridsArr: [FEED_GRID_4_PRODUCTS_1, FEED_GRID_4_PRODUCTS_2],
  },
  {
    title: "Grade com 5 produtos",
    gridsArr: [FEED_GRID_5_PRODUCTS_1, FEED_GRID_5_PRODUCTS_2],
  },
  {
    title: "Grade com 6 produtos",
    gridsArr: [FEED_GRID_6_PRODUCTS_1, FEED_GRID_6_PRODUCTS_2],
  },
  {
    title: "Grade com 7 produtos",
    gridsArr: [FEED_GRID_7_PRODUCTS_1, FEED_GRID_7_PRODUCTS_2],
  },
  {
    title: "Grade com 8 produtos",
    gridsArr: [FEED_GRID_8_PRODUCTS_1, FEED_GRID_8_PRODUCTS_2],
  },
];

const STORIES_GRID_5_PRODUCTS_1 = createGridConfig({
  quantity: 5,
  positions: [0, 1, 2, 3, 4],
  columns: ["1/4", "1/4", "1/2", "2/3", "3/4"],
  rows: ["1/2", "2/3", "3/4", "3/4", "3/4"],
  layouts: [
    THREE_COLUMNS_PRODUCT_LAYOUT,
    THREE_COLUMNS_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
  ],
  fontSizes: ["38", "38", "32", "32", "32"],
  gridCols: 3,
  gridRows: 3,
});

const STORIES_GRID_5_PRODUCTS_2 = createGridConfig({
  quantity: 5,
  positions: [0, 1, 2, 3, 4],
  columns: ["1/3", "1/3", "3/4", "3/4", "3/4"],
  rows: ["1/3", "3/4", "1/2", "2/3", "3/4"],
  layouts: [
    NAME_AND_PRICE_SIDE_BY_SIDE_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
  ],
  fontSizes: ["58", "43", "28", "32", "28"],
  gridCols: 3,
  gridRows: 3,
});

const STORIES_GRID_6_PRODUCTS_1 = createGridConfig({
  quantity: 6,
  positions: [0, 1, 2, 3, 4, 5],
  columns: ["1/2", "2/3", "3/4", "1/2", "2/3", "3/4"],
  rows: ["1/3", "1/3", "1/3", "3/4", "3/4", "3/4"],
  layouts: [
    NAME_BENEATH_PRODUCT_LAYOUT,
    NAME_BENEATH_PRODUCT_LAYOUT,
    NAME_BENEATH_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
  ],
  fontSizes: ["38", "38", "38", "33", "33", "33"],
  gridCols: 3,
  gridRows: 3,
});

const STORIES_GRID_6_PRODUCTS_2 = createGridConfig({
  quantity: 6,
  positions: [0, 1],
  columns: ["1/3", "3/5", "1/2", "2/3", "3/4", "4/5"],
  rows: ["1/3", "1/3", "3/4", "3/4", "3/4", "3/4"],
  layouts: [
    NAME_AND_PRICE_SIDE_BY_SIDE_PRODUCT_LAYOUT,
    NAME_AND_PRICE_SIDE_BY_SIDE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
  ],
  fontSizes: ["48", "48", "28", "28", "28", "28"],
  gridCols: 4,
  gridRows: 3,
});

const STORIES_GRID_7_PRODUCTS_1 = createGridConfig({
  quantity: 7,
  positions: [0, 1, 2, 3, 4, 5, 6],
  columns: ["1/3", "3/5", "1/3", "3/5", "2/4", "1/2", "4/5"],
  rows: ["1/2", "1/2", "2/3", "2/3", "3/4", "3/4", "3/4"],
  layouts: [
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
  ],
  fontSizes: ["36", "36", "36", "36", "36", "28", "28"],
  gridCols: 4,
  gridRows: 3,
});

const STORIES_GRID_7_PRODUCTS_2 = createGridConfig({
  quantity: 7,
  positions: [0, 1, 2, 3, 4, 5, 6],
  columns: ["1/2", "2/4", "4/5", "1/2", "2/3", "3/4", "4/5"],
  rows: ["1/3", "1/3", "1/3", "3/4", "3/4", "3/4", "3/4"],
  layouts: [
    NAME_BENEATH_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_BENEATH_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
  ],
  fontSizes: ["33", "53", "33", "28", "28", "28", "28"],
  gridCols: 4,
  gridRows: 3,
});

const STORIES_GRID_8_PRODUCTS_1 = createGridConfig({
  quantity: 8,
  positions: [0, 1, 2, 3, 4, 5, 6, 7],
  columns: ["1/3", "3/5", "1/2", "2/3", "1/2", "2/3", "3/4", "4/5"],
  rows: ["1/2", "1/3", "2/3", "2/3", "3/4", "3/4", "3/4", "3/4"],
  layouts: [
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    NAME_AND_PRICE_SIDE_BY_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
  ],
  fontSizes: ["36", "48", "30", "30", "26", "26", "26", "26"],
  gridCols: 4,
  gridRows: 3,
});

const STORIES_GRID_8_PRODUCTS_2 = createGridConfig({
  quantity: 8,
  positions: [0, 1, 2, 3, 4, 5, 6, 7],
  columns: ["1/4", "4/7", "1/2", "2/3", "3/4", "4/5", "5/6", "6/7"],
  rows: ["1/3", "1/3", "3/4", "3/4", "3/4", "3/4", "3/4", "3/4"],
  layouts: [
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
  ],
  fontSizes: ["68", "68", "26", "26", "26", "26", "26", "26"],
  gridCols: 6,
  gridRows: 3,
});

const STORIES_GRID_10_PRODUCTS_1 = createGridConfig({
  quantity: 10,
  positions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  columns: [
    "1/3",
    "3/5",
    "1/2",
    "2/3",
    "3/4",
    "4/5",
    "1/2",
    "2/3",
    "3/4",
    "4/5",
  ],
  rows: ["1/3", "1/3", "3/4", "3/4", "3/4", "3/4", "4/5", "4/5", "4/5", "4/5"],
  layouts: [
    NAME_AND_PRICE_SIDE_BY_SIDE_PRODUCT_LAYOUT,
    NAME_AND_PRICE_SIDE_BY_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
  ],
  fontSizes: [
    "48",
    "48",
    "26",
    "26",
    "26",
    "26",
    "24.5",
    "24.5",
    "24.5",
    "24.5",
  ],
  gridCols: 4,
  gridRows: 4,
});

const STORIES_GRID_10_PRODUCTS_2 = createGridConfig({
  quantity: 10,
  positions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  columns: [
    "1/4",
    "1/4",
    "4/5",
    "5/6",
    "4/5",
    "5/6",
    "4/5",
    "5/6",
    "4/5",
    "5/6",
  ],
  rows: ["1/3", "3/6", "1/2", "1/2", "2/3", "2/3", "3/4", "3/4", "4/5", "4/5"],
  layouts: [
    NAME_AND_PRICE_SIDE_BY_SIDE_PRODUCT_LAYOUT,
    NAME_AND_PRICE_SIDE_BY_SIDE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
  ],
  fontSizes: ["58", "58", "23", "23", "23", "23", "23", "23", "23", "23"],
  gridCols: 5,
  gridRows: 4,
});

const STORIES_GRID_12_PRODUCTS_1 = createGridConfig({
  quantity: 12,
  positions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
  columns: [
    "1/2",
    "2/3",
    "3/4",
    "4/5",
    "1/2",
    "2/3",
    "3/4",
    "4/5",
    "1/2",
    "2/3",
    "3/4",
    "4/5",
  ],
  rows: [
    "1/2",
    "1/2",
    "1/2",
    "1/2",
    "2/3",
    "2/3",
    "2/3",
    "2/3",
    "3/4",
    "3/4",
    "3/4",
    "3/4",
  ],
  layouts: [
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
  ],
  fontSizes: [
    "32",
    "32",
    "32",
    "32",
    "26",
    "26",
    "26",
    "26",
    "32",
    "32",
    "32",
    "32",
  ],
  gridCols: 4,
  gridRows: 3,
});

const STORIES_GRID_12_PRODUCTS_2 = createGridConfig({
  quantity: 12,
  positions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
  columns: [
    "1/4",
    "4/6",
    "4/5",
    "5/6",
    "4/5",
    "5/6",
    "1/2",
    "2/3",
    "3/4",
    "1/2",
    "2/3",
    "3/4",
  ],
  rows: [
    "1/3",
    "3/5",
    "1/2",
    "1/2",
    "2/3",
    "2/3",
    "3/4",
    "3/4",
    "3/4",
    "4/5",
    "4/5",
    "4/5",
  ],
  layouts: [
    NAME_AND_PRICE_SIDE_BY_SIDE_PRODUCT_LAYOUT,
    NAME_AND_PRICE_SIDE_BY_SIDE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
  ],
  fontSizes: [
    "58",
    "38",
    "23",
    "23",
    "23",
    "23",
    "24",
    "24",
    "24",
    "24",
    "24",
    "24",
  ],
  gridCols: 5,
  gridRows: 4,
});

export const STORIES_GRIDS = [
  {
    title: "Grade com 5 produtos",
    gridsArr: [STORIES_GRID_5_PRODUCTS_1, STORIES_GRID_5_PRODUCTS_2],
  },
  {
    title: "Grade com 6 produtos",
    gridsArr: [STORIES_GRID_6_PRODUCTS_1, STORIES_GRID_6_PRODUCTS_2],
  },
  {
    title: "Grade com 7 produtos",
    gridsArr: [STORIES_GRID_7_PRODUCTS_1, STORIES_GRID_7_PRODUCTS_2],
  },
  {
    title: "Grade com 8 produtos",
    gridsArr: [STORIES_GRID_8_PRODUCTS_1, STORIES_GRID_8_PRODUCTS_2],
  },
  {
    title: "Grade com 10 produtos",
    gridsArr: [STORIES_GRID_10_PRODUCTS_1, STORIES_GRID_10_PRODUCTS_2],
  },
  {
    title: "Grade com 12 produtos",
    gridsArr: [STORIES_GRID_12_PRODUCTS_1, STORIES_GRID_12_PRODUCTS_2],
  },
];
const PANFLETO_GRID_5_PRODUCTS_1 = createGridConfig({
  quantity: 5,
  positions: [0, 1, 2, 3, 4],
  columns: ["1/4", "4/7", "1/3", "3/5", "5/7"],
  rows: ["1/2", "1/2", "2/3", "2/3", "2/3"],
  layouts: [
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
  ],
  fontSizes: ["58", "58", "58", "58", "58"],
  gridCols: 6,
  gridRows: 2,
});

const PANFLETO_GRID_5_PRODUCTS_2 = createGridConfig({
  quantity: 5,
  positions: [0, 1, 2, 3, 4],
  columns: ["2/4", "1/2", "1/2", "4/5", "4/5"],
  rows: ["1/5", "1/3", "3/5", "1/3", "3/5"],
  layouts: [
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
  ],
  fontSizes: ["98", "53", "53", "53", "53"],
  gridCols: 4,
  gridRows: 4,
});

const PANFLETO_GRID_6_PRODUCTS_1 = createGridConfig({
  quantity: 6,
  positions: [0, 1, 2, 3, 4, 5],
  columns: ["1/2", "2/3", "3/4", "1/2", "2/3", "3/4"],
  rows: ["1/2", "1/2", "1/2", "2/3", "2/3", "2/3"],
  layouts: [
    NAME_ABOVE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
  ],
  fontSizes: ["58", "63", "58", "58", "63", "58"],
  gridCols: 3,
  gridRows: 2,
});

const PANFLETO_GRID_6_PRODUCTS_2 = createGridConfig({
  quantity: 6,
  positions: [0, 1, 2, 3, 4, 5],
  columns: ["1/3", "3/5", "1/2", "2/3", "3/4", "4/5"],
  rows: ["2/3", "2/3", "1/2", "1/2", "1/2", "1/2"],
  layouts: [
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    NAME_BENEATH_PRODUCT_LAYOUT,
    NAME_BENEATH_PRODUCT_LAYOUT,
    NAME_BENEATH_PRODUCT_LAYOUT,
    NAME_BENEATH_PRODUCT_LAYOUT,
  ],
  fontSizes: ["53", "53", "43", "43", "43", "43"],
  gridCols: 4,
  gridRows: 2,
});

const PANFLETO_GRID_9_PRODUCTS_1 = createGridConfig({
  quantity: 9,
  positions: [0, 1, 2, 3, 4, 5, 6, 7, 8],
  columns: ["2/4", "2/4", "2/4", "1/2", "1/2", "1/2", "1/2", "2/3", "3/4"],
  rows: ["1/2", "2/3", "3/4", "1/2", "2/3", "3/4", "4/5", "4/5", "4/5"],
  layouts: [
    THREE_COLUMNS_PRODUCT_LAYOUT,
    THREE_COLUMNS_PRODUCT_LAYOUT,
    THREE_COLUMNS_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
  ],
  fontSizes: ["40", "40", "40", "32", "32", "32", "32", "32", "32"],
  gridCols: 3,
  gridRows: 4,
});

const PANFLETO_GRID_9_PRODUCTS_2 = createGridConfig({
  quantity: 9,
  positions: [0, 1, 2, 3, 4, 5, 6, 7, 8],
  columns: ["1/3", "3/5", "5/7", "1/2", "2/3", "3/4", "4/5", "5/6", "6/7"],
  rows: ["1/3", "1/3", "1/3", "3/4", "3/4", "3/4", "3/4", "3/4", "3/4"],
  layouts: [
    NAME_BENEATH_PRODUCT_LAYOUT,
    NAME_BENEATH_PRODUCT_LAYOUT,
    NAME_BENEATH_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
  ],
  fontSizes: ["53", "53", "53", "32", "32", "32", "32", "32", "32"],
  gridCols: 6,
  gridRows: 3,
});

const PANFLETO_GRID_10_PRODUCTS_1 = createGridConfig({
  quantity: 10,
  positions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  columns: [
    "1/4",
    "1/4",
    "4/6",
    "6/8",
    "4/6",
    "4/6",
    "4/6",
    "6/8",
    "6/8",
    "6/8",
  ],
  rows: ["1/4", "4/7", "1/4", "1/4", "4/5", "5/6", "6/7", "4/5", "5/6", "6/7"],
  layouts: [
    NAME_AND_PRICE_SIDE_BY_SIDE_PRODUCT_LAYOUT,
    NAME_AND_PRICE_SIDE_BY_SIDE_PRODUCT_LAYOUT,
    NAME_BENEATH_PRODUCT_LAYOUT,
    NAME_BENEATH_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
  ],
  fontSizes: ["53", "53", "43", "43", "28", "28", "28", "28", "28", "28"],
  gridCols: 7,
  gridRows: 6,
});

const PANFLETO_GRID_10_PRODUCTS_2 = createGridConfig({
  quantity: 10,
  positions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
  columns: [
    "1/3",
    "3/5",
    "1/2",
    "2/3",
    "3/4",
    "4/5",
    "1/2",
    "2/3",
    "3/4",
    "4/5",
  ],
  rows: ["1/3", "1/3", "3/4", "3/4", "3/4", "3/4", "4/5", "4/5", "4/5", "4/5"],
  layouts: [
    NAME_AND_PRICE_SIDE_BY_SIDE_PRODUCT_LAYOUT,
    NAME_AND_PRICE_SIDE_BY_SIDE_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
  ],
  fontSizes: ["58", "58", "32", "32", "32", "32", "36", "36", "36", "36"],
  gridCols: 4,
  gridRows: 4,
});

const PANFLETO_GRID_11_PRODUCTS_1 = createGridConfig({
  quantity: 11,
  positions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  columns: [
    "1/4",
    "1/4",
    "4/5",
    "5/6",
    "6/7",
    "4/5",
    "5/6",
    "6/7",
    "4/5",
    "5/6",
    "6/7",
  ],
  rows: [
    "1/4",
    "4/7",
    "1/3",
    "1/3",
    "1/3",
    "3/5",
    "3/5",
    "3/5",
    "5/7",
    "5/7",
    "5/7",
  ],
  layouts: [
    NAME_AND_PRICE_SIDE_BY_SIDE_PRODUCT_LAYOUT,
    NAME_AND_PRICE_SIDE_BY_SIDE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
  ],
  fontSizes: ["63", "63", "33", "33", "33", "33", "33", "33", "33", "33", "33"],
  gridCols: 6,
  gridRows: 6,
});

const PANFLETO_GRID_11_PRODUCTS_2 = createGridConfig({
  quantity: 11,
  positions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  columns: [
    "1/5",
    "5/9",
    "9/13",
    "1/4",
    "4/7",
    "7/10",
    "10/13",
    "1/4",
    "4/7",
    "7/10",
    "10/13",
  ],
  rows: [
    "1/3",
    "1/3",
    "1/3",
    "3/4",
    "3/4",
    "3/4",
    "3/4",
    "4/5",
    "4/5",
    "4/5",
    "4/5",
  ],
  layouts: [
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
  ],
  fontSizes: ["48", "48", "48", "33", "33", "33", "33", "38", "38", "38", "38"],
  gridCols: 12,
  gridRows: 4,
});

const PANFLETO_GRID_12_PRODUCTS_1 = createGridConfig({
  quantity: 12,
  positions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
  columns: [
    "1/7",
    "1/7",
    "1/7",
    "7/10",
    "10/13",
    "13/16",
    "7/10",
    "10/13",
    "13/16",
    "7/10",
    "10/13",
    "13/16",
  ],
  rows: [
    "1/6",
    "6/11",
    "11/16",
    "1/6",
    "1/6",
    "1/6",
    "6/11",
    "6/11",
    "6/11",
    "11/16",
    "11/16",
    "11/16",
  ],
  layouts: [
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
  ],
  fontSizes: [
    "43",
    "43",
    "43",
    "33",
    "33",
    "33",
    "33",
    "33",
    "33",
    "33",
    "33",
    "33",
    "33",
    "33",
  ],
  gridCols: 15,
  gridRows: 15,
});

const PANFLETO_GRID_12_PRODUCTS_2 = createGridConfig({
  quantity: 11,
  positions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  columns: [
    "1/5",
    "5/9",
    "9/13",
    "1/4",
    "4/7",
    "7/10",
    "10/13",
    "1/4",
    "4/7",
    "7/10",
    "10/13",
  ],
  rows: [
    "1/3",
    "1/3",
    "1/3",
    "3/4",
    "3/4",
    "3/4",
    "3/4",
    "4/5",
    "4/5",
    "4/5",
    "4/5",
  ],
  layouts: [
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
  ],
  fontSizes: ["53", "53", "53", "33", "33", "33", "33", "33", "33", "33", "33"],
  gridCols: 12,
  gridRows: 4,
});

const PANFLETO_GRID_13_PRODUCTS_1 = createGridConfig({
  quantity: 13,
  positions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  columns: [
    "2/4",
    "1/2",
    "2/3",
    "3/4",
    "4/5",
    "4/5",
    "4/5",
    "4/5",
    "3/4",
    "2/3",
    "1/2",
    "1/2",
    "1/2",
    "1/2",
  ],
  rows: [
    "2/4",
    "1/2",
    "1/2",
    "1/2",
    "1/2",
    "2/3",
    "3/4",
    "4/5",
    "4/5",
    "4/5",
    "4/5",
    "3/4",
    "2/3",
  ],
  layouts: [
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
  ],
  fontSizes: [
    "63",
    "28",
    "33",
    "33",
    "28",
    "33",
    "33",
    "28",
    "33",
    "33",
    "28",
    "33",
    "33",
  ],
  gridCols: 4,
  gridRows: 4,
});

const PANFLETO_GRID_13_PRODUCTS_2 = createGridConfig({
  quantity: 13,
  positions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  columns: [
    "1/3",
    "3/5",
    "1/3",
    "3/5",
    "5/6",
    "6/7",
    "7/8",
    "5/6",
    "6/7",
    "7/8",
    "5/6",
    "6/7",
    "7/8",
  ],
  rows: [
    "1/4",
    "1/4",
    "4/7",
    "4/7",
    "1/3",
    "1/3",
    "1/3",
    "3/5",
    "3/5",
    "3/5",
    "5/7",
    "5/7",
    "5/7",
  ],
  layouts: [
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
  ],
  fontSizes: [
    "48",
    "48",
    "48",
    "48",
    "28",
    "28",
    "28",
    "28",
    "28",
    "28",
    "28",
    "28",
    "28",
  ],
  gridCols: 7,
  gridRows: 6,
});

const PANFLETO_GRID_14_PRODUCTS_1 = createGridConfig({
  quantity: 14,
  positions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  columns: [
    "1/6",
    "6/11",
    "11/16",
    "16/21",
    "1/5",
    "5/9",
    "9/13",
    "13/17",
    "17/21",
    "1/5",
    "5/9",
    "9/13",
    "13/17",
    "17/21",
  ],
  rows: [
    "1/4",
    "1/4",
    "1/4",
    "1/4",
    "4/5",
    "4/5",
    "4/5",
    "4/5",
    "4/5",
    "5/6",
    "5/6",
    "5/6",
    "5/6",
    "5/6",
  ],
  layouts: [
    NAME_BENEATH_PRODUCT_LAYOUT,
    NAME_BENEATH_PRODUCT_LAYOUT,
    NAME_BENEATH_PRODUCT_LAYOUT,
    NAME_BENEATH_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
  ],
  fontSizes: [
    "45",
    "45",
    "45",
    "45",
    "25",
    "25",
    "25",
    "25",
    "25",
    "32",
    "32",
    "32",
    "32",
    "32",
  ],
  gridCols: 20,
  gridRows: 5,
});

const PANFLETO_GRID_14_PRODUCTS_2 = createGridConfig({
  quantity: 14,
  positions: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  columns: [
    "1/3",
    "3/5",
    "1/3",
    "3/5",
    "1/3",
    "3/5",
    "5/6",
    "6/7",
    "5/6",
    "6/7",
    "5/6",
    "6/7",
    "5/6",
    "6/7",
  ],
  rows: [
    "1/5",
    "1/5",
    "5/9",
    "5/9",
    "9/13",
    "9/13",
    "1/4",
    "1/4",
    "4/7",
    "4/7",
    "7/10",
    "7/10",
    "10/13",
    "10/13",
  ],
  layouts: [
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
    NAME_ABOVE_PRODUCT_LAYOUT,
  ],
  fontSizes: [
    "46",
    "46",
    "46",
    "46",
    "46",
    "46",
    "28",
    "28",
    "28",
    "28",
    "28",
    "28",
    "28",
    "28",
  ],
  gridCols: 6,
  gridRows: 12,
});

export const PANFLETO_GRID = [
  {
    title: "Grade com 5 produtos",
    gridsArr: [PANFLETO_GRID_5_PRODUCTS_1, PANFLETO_GRID_5_PRODUCTS_2],
  },
  {
    title: "Grade com 6 produtos",
    gridsArr: [PANFLETO_GRID_6_PRODUCTS_1, PANFLETO_GRID_6_PRODUCTS_2],
  },
  {
    title: "Grade com 9 produtos",
    gridsArr: [PANFLETO_GRID_9_PRODUCTS_1, PANFLETO_GRID_9_PRODUCTS_2],
  },
  {
    title: "Grade com 10 produtos",
    gridsArr: [PANFLETO_GRID_10_PRODUCTS_1, PANFLETO_GRID_10_PRODUCTS_2],
  },
  {
    title: "Grade com 11 produtos",
    gridsArr: [PANFLETO_GRID_11_PRODUCTS_1, PANFLETO_GRID_11_PRODUCTS_2],
  },
  {
    title: "Grade com 12 produtos",
    gridsArr: [PANFLETO_GRID_12_PRODUCTS_1, PANFLETO_GRID_12_PRODUCTS_2],
  },
  {
    title: "Grade com 13 produtos",
    gridsArr: [PANFLETO_GRID_13_PRODUCTS_1, PANFLETO_GRID_13_PRODUCTS_2],
  },
  {
    title: "Grade com 14 produtos",
    gridsArr: [PANFLETO_GRID_14_PRODUCTS_1, PANFLETO_GRID_14_PRODUCTS_2],
  },
];

export function Grid(columns, rows, autoGrid = false) {
  return {
    columns: columns,
    rows: rows,
    autoGrid: autoGrid,
  };
}

/* AUTO GRIDS */

export const AUTO_GRID_POSITIONS_FEED = {
  1: {
    grid: { columns: 1, rows: 1 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "78",
      },
    ],
  },
  2: {
    grid: { columns: 2, rows: 1 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "48",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "48",
      },
    ],
  },

  3: {
    grid: { columns: 3, rows: 1 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "43",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "43",
      },
      {
        column: "3/4",
        row: "1/2",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "43",
      },
    ],
  },

  4: {
    grid: { columns: 2, rows: 2 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "38",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "38",
      },
      {
        column: "1/2",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "38",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "38",
      },
    ],
  },
  5: {
    grid: { columns: 3, rows: 2 },
    styles: [
      {
        column: "1/3",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "38",
      },
      {
        column: "3/4",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "33",
      },
      {
        column: "1/2",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "33",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "33",
      },
      {
        column: "3/4",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "33",
      },
    ],
  },
  6: {
    grid: { columns: 3, rows: 2 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "3/4",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "1/2",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "3/4",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "28",
      },
    ],
  },
  7: {
    grid: { columns: 4, rows: 2 },
    styles: [
      {
        column: "1/3",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "3/4",
        row: "1/2",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "23",
      },
      {
        column: "4/5",
        row: "1/2",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "23",
      },
      {
        column: "1/2",
        row: "2/3",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "23",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "23",
      },
      {
        column: "3/4",
        row: "2/3",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "23",
      },
      {
        column: "4/5",
        row: "2/3",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "23",
      },
    ],
  },

  8: {
    grid: { columns: 4, rows: 2 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "25",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "25",
      },
      {
        column: "3/4",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "25",
      },
      {
        column: "4/5",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "25",
      },
      {
        column: "1/2",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "25",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "25",
      },
      {
        column: "3/4",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "25",
      },
      {
        column: "4/5",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "25",
      },
    ],
  },
};

export const AUTO_GRID_POSITIONS_FEED_PORTRAIT = {
  1: {
    grid: { columns: 1, rows: 1 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "83", // 80 + 5
      },
    ],
  },
  2: {
    grid: { columns: 2, rows: 1 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "53", // 50 + 5
      },
      {
        column: "2/3",
        row: "1/2",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "53", // 50 + 5
      },
    ],
  },

  3: {
    grid: { columns: 3, rows: 1 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "48", // 45 + 5
      },
      {
        column: "2/3",
        row: "1/2",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "48", // 45 + 5
      },
      {
        column: "3/4",
        row: "1/2",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "48", // 45 + 5
      },
    ],
  },

  4: {
    grid: { columns: 2, rows: 2 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "43", // 40 + 5
      },
      {
        column: "2/3",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "43", // 40 + 5
      },
      {
        column: "1/2",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "43", // 40 + 5
      },
      {
        column: "2/3",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "43", // 40 + 5
      },
    ],
  },
  5: {
    grid: { columns: 3, rows: 2 },
    styles: [
      {
        column: "1/3",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "43", // 40 + 5
      },
      {
        column: "3/4",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "38", // 35 + 5
      },
      {
        column: "1/2",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "38", // 35 + 5
      },
      {
        column: "2/3",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "38", // 35 + 5
      },
      {
        column: "3/4",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "38", // 35 + 5
      },
    ],
  },
  6: {
    grid: { columns: 3, rows: 2 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "38", // 30 + 5
      },
      {
        column: "2/3",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "38", // 30 + 5
      },
      {
        column: "3/4",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "38", // 30 + 5
      },
      {
        column: "1/2",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "38", // 30 + 5
      },
      {
        column: "2/3",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "38", // 30 + 5
      },
      {
        column: "3/4",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "38", // 30 + 5
      },
    ],
  },
  7: {
    grid: { columns: 4, rows: 2 },
    styles: [
      {
        column: "1/3",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "33", // 30 + 5
      },
      {
        column: "3/4",
        row: "1/2",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "28", // 25 + 5
      },
      {
        column: "4/5",
        row: "1/2",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "28", // 25 + 5
      },
      {
        column: "1/2",
        row: "2/3",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "28", // 25 + 5
      },
      {
        column: "2/3",
        row: "2/3",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "28", // 25 + 5
      },
      {
        column: "3/4",
        row: "2/3",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "28", // 25 + 5
      },
      {
        column: "4/5",
        row: "2/3",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "28", // 25 + 5
      },
    ],
  },

  8: {
    grid: { columns: 4, rows: 2 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "30", // 27 + 5
      },
      {
        column: "2/3",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "30", // 27 + 5
      },
      {
        column: "3/4",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "30", // 27 + 5
      },
      {
        column: "4/5",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "30", // 27 + 5
      },
      {
        column: "1/2",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "30", // 27 + 5
      },
      {
        column: "2/3",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "30", // 27 + 5
      },
      {
        column: "3/4",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "30", // 27 + 5
      },
      {
        column: "4/5",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "30", // 27 + 5
      },
    ],
  },
};

export const AUTO_GRID_POSITIONS_STORIES = {
  1: {
    grid: { columns: 1, rows: 1 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "118",
      },
    ],
  },
  2: {
    grid: { columns: 1, rows: 2 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: THREE_COLUMNS_PRODUCT_LAYOUT,
        fontSize: "48",
      },
      {
        column: "1/2",
        row: "2/3",
        layout: THREE_COLUMNS_PRODUCT_LAYOUT,
        fontSize: "48",
      },
    ],
  },
  3: {
    grid: { columns: 1, rows: 3 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: THREE_COLUMNS_PRODUCT_LAYOUT,
        fontSize: "43",
      },
      {
        column: "1/2",
        row: "2/3",
        layout: THREE_COLUMNS_PRODUCT_LAYOUT,
        fontSize: "43",
      },
      {
        column: "1/2",
        row: "3/4",
        layout: THREE_COLUMNS_PRODUCT_LAYOUT,
        fontSize: "43",
      },
    ],
  },
  4: {
    grid: { columns: 2, rows: 2 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "53",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "53",
      },
      {
        column: "1/2",
        row: "2/3",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "53",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "53",
      },
    ],
  },
  5: {
    grid: { columns: 2, rows: 3 },
    styles: [
      {
        column: "1/2",
        row: "1/3",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "63",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "38",
      },
      {
        column: "1/2",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "38",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "38",
      },
      {
        column: "2/3",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "38",
      },
    ],
  },

  6: {
    grid: { columns: 2, rows: 3 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "38",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "38",
      },
      {
        column: "1/2",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "38",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "38",
      },
      {
        column: "1/2",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "38",
      },
      {
        column: "2/3",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "38",
      },
    ],
  },
  7: {
    grid: { columns: 3, rows: 3 },
    styles: [
      {
        column: "1/2",
        row: "1/3",
        layout: NAME_BENEATH_PRODUCT_LAYOUT,
        fontSize: "40",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "31",
      },
      {
        column: "3/4",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "31",
      },
      {
        column: "1/2",
        row: "3/4",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "31",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "31",
      },
      {
        column: "3/4",
        row: "2/4",
        layout: NAME_BENEATH_PRODUCT_LAYOUT,
        fontSize: "40",
      },
      {
        column: "2/3",
        row: "3/4",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "31",
      },
    ],
  },
  8: {
    grid: { columns: 3, rows: 3 },
    styles: [
      {
        column: "1/2",
        row: "1/3",
        layout: NAME_BENEATH_PRODUCT_LAYOUT,
        fontSize: "48",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "33",
      },
      {
        column: "3/4",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "33",
      },
      {
        column: "1/2",
        row: "3/4",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "33",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "33",
      },
      {
        column: "3/4",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "33",
      },
      {
        column: "2/3",
        row: "3/4",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "33",
      },
      {
        column: "3/4",
        row: "3/4",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "33",
      },
    ],
  },
  9: {
    grid: { columns: 3, rows: 3 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "33",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "33",
      },
      {
        column: "3/4",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "33",
      },
      {
        column: "1/2",
        row: "2/3",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "33",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "33",
      },
      {
        column: "3/4",
        row: "2/3",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "33",
      },
      {
        column: "1/2",
        row: "3/4",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "33",
      },
      {
        column: "2/3",
        row: "3/4",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "33",
      },
      {
        column: "3/4",
        row: "3/4",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "33",
      },
    ],
  },
  10: {
    grid: { columns: 3, rows: 4 },
    styles: [
      {
        column: "1/2",
        row: "1/3",
        layout: NAME_BENEATH_PRODUCT_LAYOUT,
        fontSize: "53",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "30",
      },
      {
        column: "3/4",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "30",
      },
      {
        column: "1/2",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "30",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "30",
      },
      {
        column: "3/4",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "30",
      },
      {
        column: "1/2",
        row: "4/5",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "30",
      },
      {
        column: "2/3",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "30",
      },
      {
        column: "3/4",
        row: "3/5",
        layout: NAME_BENEATH_PRODUCT_LAYOUT,
        fontSize: "53",
      },
      {
        column: "2/3",
        row: "4/5",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "2326",
      },
    ],
  },
  11: {
    grid: { columns: 3, rows: 4 },
    styles: [
      {
        column: "1/2",
        row: "1/3",
        layout: NAME_BENEATH_PRODUCT_LAYOUT,
        fontSize: "48",
      },
      {
        column: "1/2",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "1/2",
        row: "4/5",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "2/3",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "2/3",
        row: "4/5",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "3/4",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "3/4",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "3/4",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "3/4",
        row: "4/5",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "28",
      },
    ],
  },

  12: {
    grid: { columns: 3, rows: 4 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "30",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "26",
      },
      {
        column: "3/4",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "26",
      },
      {
        column: "1/2",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "26",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "26",
      },
      {
        column: "3/4",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "26",
      },
      {
        column: "1/2",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "26",
      },
      {
        column: "2/3",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "26",
      },
      {
        column: "3/4",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "26",
      },
      {
        column: "1/2",
        row: "4/5",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "26",
      },
      {
        column: "2/3",
        row: "4/5",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "26",
      },
      {
        column: "3/4",
        row: "4/5",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "26",
      },
    ],
  },
};

export const AUTO_GRID_POSITIONS_PANFLETO = {
  ...AUTO_GRID_POSITIONS_STORIES,
  2: {
    grid: { columns: 1, rows: 2 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: THREE_COLUMNS_PRODUCT_LAYOUT,
        fontSize: "80",
      },
      {
        column: "1/2",
        row: "2/3",
        layout: THREE_COLUMNS_PRODUCT_LAYOUT,
        fontSize: "80",
      },
    ],
  },
  3: {
    grid: { columns: 1, rows: 3 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: THREE_COLUMNS_PRODUCT_LAYOUT,
        fontSize: "70",
      },
      {
        column: "1/2",
        row: "2/3",
        layout: THREE_COLUMNS_PRODUCT_LAYOUT,
        fontSize: "70",
      },
      {
        column: "1/2",
        row: "3/4",
        layout: THREE_COLUMNS_PRODUCT_LAYOUT,
        fontSize: "70",
      },
    ],
  },
  4: {
    grid: { columns: 2, rows: 2 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "55",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "55",
      },
      {
        column: "1/2",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "55",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "55",
      },
    ],
  },
  5: {
    grid: { columns: 2, rows: 3 },
    styles: [
      {
        column: "1/2",
        row: "1/3",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "70",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "50",
      },
      {
        column: "1/2",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "50",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "50",
      },
      {
        column: "2/3",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "50",
      },
    ],
  },

  6: {
    grid: { columns: 2, rows: 3 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "50",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "50",
      },
      {
        column: "1/2",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "50",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "50",
      },
      {
        column: "1/2",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "50",
      },
      {
        column: "2/3",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "50",
      },
    ],
  },
  7: {
    grid: { columns: 3, rows: 3 },
    styles: [
      {
        column: "1/2",
        row: "1/3",
        layout: NAME_BENEATH_PRODUCT_LAYOUT,
        fontSize: "55",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "42",
      },
      {
        column: "3/4",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "47",
      },
      {
        column: "1/2",
        row: "3/4",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "47",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "42",
      },
      {
        column: "3/4",
        row: "2/4",
        layout: NAME_BENEATH_PRODUCT_LAYOUT,
        fontSize: "55",
      },
      {
        column: "2/3",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "42",
      },
    ],
  },
  8: {
    grid: { columns: 3, rows: 3 },
    styles: [
      {
        column: "1/2",
        row: "1/3",
        layout: NAME_BENEATH_PRODUCT_LAYOUT,
        fontSize: "65",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "45",
      },
      {
        column: "3/4",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "40",
      },
      {
        column: "1/2",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "40",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "40",
      },
      {
        column: "3/4",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "45",
      },
      {
        column: "2/3",
        row: "3/4",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "45",
      },
      {
        column: "3/4",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "40",
      },
    ],
  },
  9: {
    grid: { columns: 3, rows: 3 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "45",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "45",
      },
      {
        column: "3/4",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "45",
      },
      {
        column: "1/2",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "38",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "38",
      },
      {
        column: "3/4",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "38",
      },
      {
        column: "1/2",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "38",
      },
      {
        column: "2/3",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "38",
      },
      {
        column: "3/4",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "38",
      },
    ],
  },
  10: {
    grid: { columns: 3, rows: 4 },
    styles: [
      {
        column: "1/2",
        row: "1/3",
        layout: NAME_BENEATH_PRODUCT_LAYOUT,
        fontSize: "55",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "3/4",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "1/2",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "3/4",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "1/2",
        row: "4/5",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "2/3",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "3/4",
        row: "3/5",
        layout: NAME_BENEATH_PRODUCT_LAYOUT,
        fontSize: "55",
      },
      {
        column: "2/3",
        row: "4/5",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "28",
      },
    ],
  },
  11: {
    grid: { columns: 3, rows: 4 },
    styles: [
      {
        column: "1/2",
        row: "1/3",
        layout: NAME_BENEATH_PRODUCT_LAYOUT,
        fontSize: "55",
      },
      {
        column: "1/2",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "36.5",
      },
      {
        column: "1/2",
        row: "4/5",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "36.5",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "36.5",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "36.5",
      },
      {
        column: "2/3",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "36.5",
      },
      {
        column: "2/3",
        row: "4/5",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "36.5",
      },
      {
        column: "3/4",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "36.5",
      },
      {
        column: "3/4",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "40",
      },
      {
        column: "3/4",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "36.5",
      },
      {
        column: "3/4",
        row: "4/5",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "36.5",
      },
    ],
  },
  12: {
    grid: { columns: 3, rows: 4 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "38",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "40",
      },
      {
        column: "3/4",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "40",
      },
      {
        column: "1/2",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "38",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "40",
      },
      {
        column: "3/4",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "40",
      },
      {
        column: "1/2",
        row: "3/4",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "38",
      },
      {
        column: "2/3",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "40",
      },
      {
        column: "3/4",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "40",
      },
      {
        column: "1/2",
        row: "4/5",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "35",
      },
      {
        column: "2/3",
        row: "4/5",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "40",
      },
      {
        column: "3/4",
        row: "4/5",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "40",
      },
    ],
  },
  13: {
    grid: { columns: 3, rows: 5 },
    styles: [
      {
        column: "1/2",
        row: "1/3",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "48",
      },
      {
        column: "1/2",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "1/2",
        row: "4/5",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "1/2",
        row: "5/6",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "2/3",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "2/3",
        row: "4/5",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "2/3",
        row: "5/6",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "3/4",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "3/4",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "3/4",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "3/4",
        row: "4/6",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "48",
      },
    ],
  },
  14: {
    grid: { columns: 4, rows: 4 },
    styles: [
      {
        column: "1/2",
        row: "1/3",
        layout: NAME_BENEATH_PRODUCT_LAYOUT,
        fontSize: "45",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "3/4",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "4/5",
        row: "1/2",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "1/2",
        row: "3/4",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "34",
      },
      {
        column: "3/4",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "34",
      },
      {
        column: "4/5",
        row: "2/3",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "1/2",
        row: "4/5",
        layout: NAME_ABOVE_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "2/3",
        row: "3/4",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "34",
      },
      {
        column: "3/4",
        row: "3/4",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "34",
      },
      {
        column: "2/3",
        row: "4/5",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "34",
      },
      {
        column: "3/4",
        row: "4/5",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "34",
      },
      {
        column: "4/5",
        row: "3/5",
        layout: NAME_BENEATH_PRODUCT_LAYOUT,
        fontSize: "45",
      },
    ],
  },
  15: {
    grid: { columns: 4, rows: 4 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "3/4",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "4/5",
        row: "1/2",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "1/2",
        row: "3/4",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "3/4",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "4/5",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "1/2",
        row: "4/5",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "2/3",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "3/4",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "4/5",
        row: "3/5",
        layout: NAME_BENEATH_PRODUCT_LAYOUT,
        fontSize: "50",
      },
      {
        column: "1/2",
        row: "2/3",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "32",
      },
      {
        column: "2/3",
        row: "4/5",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "3/4",
        row: "4/5",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "28",
      },
    ],
  },
  16: {
    grid: { columns: 4, rows: 4 },
    styles: [
      {
        column: "1/2",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "2/3",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "3/4",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "4/5",
        row: "1/2",
        layout: PRICE_IMAGE_SIDE_PRODUCT_LAYOUT,
        fontSize: "28",
      },
      {
        column: "1/2",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "26",
      },
      {
        column: "2/3",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "26",
      },
      {
        column: "3/4",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "26",
      },
      {
        column: "4/5",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "26",
      },
      {
        column: "1/2",
        row: "4/5",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "26",
      },
      {
        column: "2/3",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "26",
      },
      {
        column: "3/4",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "26",
      },
      {
        column: "4/5",
        row: "3/4",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "26",
      },
      {
        column: "1/2",
        row: "2/3",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "26",
      },
      {
        column: "2/3",
        row: "4/5",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "26",
      },
      {
        column: "3/4",
        row: "4/5",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "26",
      },

      {
        column: "4/5",
        row: "4/5",
        layout: TWO_COLUMNS_NAME_LEFT_PRODUCT_LAYOUT,
        fontSize: "26",
      },
    ],
  },
};
